import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import CompactToggle from '~/components/toolbar/shared/CompactToggle';
import { BrushTool } from '~/engine/tool/tools/contouring-tools/BrushTool';
import { brushOptionsState, StrokeMode } from '~/state/atoms/toolsAtoms';
import { cmToMm, formatMmAsCm, mmToCm } from '~/utils/units';
import ToolTrayModeToggle from './ToolTrayModeToggle';
import ToolTraySlider from './ToolTraySlider';
import { toolTrayRowSx } from './toolTraySx';

export default function BrushToolOptions() {
    const [brushOptions, setBrushOptions] = useRecoilState(brushOptionsState);

    const handleSetStrokeMode = (strokeMode: StrokeMode) => {
        setBrushOptions((options) => ({ ...options, strokeMode }));
    };

    const handleSetBrushSize = (valueCm: number) => {
        const clampedCm = Math.max(0.2, valueCm);
        const newDiameter = cmToMm(clampedCm);
        if (newDiameter > BrushTool.MAX_BRUSH_SIZE) {
            return;
        }
        setBrushOptions((options) => ({ ...options, diameter: newDiameter }));
    };

    return (
        <Box sx={toolTrayRowSx}>
            <ToolTrayModeToggle
                value={brushOptions.strokeMode}
                onChange={handleSetStrokeMode}
                testIdPrefix="brush-mode"
            />
            <ToolTraySlider
                value={mmToCm(brushOptions.diameter)}
                onChange={handleSetBrushSize}
                step={0.1}
                min={-0.4}
                max={4.0}
                thumbMarginLeft="-7px"
                valueText={`${formatMmAsCm(brushOptions.diameter, 1)} cm`}
            />

            {brushOptions.erase && (
                <CompactToggle
                    labelId="adaptiveErase"
                    tooltipId="eraseSmartTooltip"
                    value={brushOptions.mode === 'smart'}
                    onChange={(adaptive) =>
                        setBrushOptions((options) => ({
                            ...options,
                            mode: adaptive ? 'smart' : 'static',
                        }))
                    }
                />
            )}
            {/*
             * Auto-suggest now lives in the Modifiers menu
             * (DrawingConstraintsControl), at the top of the list, so it is
             * shared across contouring tools rather than duplicated per-tray.
             */}
        </Box>
    );
}
